'use client';

import { PropsWithChildren } from 'react';

import { PostHogProvider as SharedPostHogProvider } from '@bazak/analytics/provider';

import { POSTHOG_ENABLED } from '@/common/constants';

export function PostHogProvider({ children }: PropsWithChildren) {
  return <SharedPostHogProvider enabled={POSTHOG_ENABLED}>{children}</SharedPostHogProvider>;
}
